/*
  页面路由配置规则：

  path：页面访问路径
  name：路由名称 注意：该值需唯一
  component：页面组件路径 （其中 webpackChunkName: "layout" 不要删，需要通过它来做代码打包拆分，layout可以取路由名称name值，需保持唯一）
  redirect：路由重定向（按需使用）
  hidden：是否不在菜单栏中显示 true：隐藏 false：显示   注意：默认不需配置此字段，只有需要隐藏时配置（通常子页面需要配置该字段）
  meta：附加信息
    title：菜单标题 设置为语言管理中对应的key 规则为：应用名称_路由中定义的页面name值 如：示例应用_示例页面 -> base_demo
    icon：菜单图标  注意：只有一级页面才有该字段
    activeMenuTitle：进入子页面时左侧菜单栏中高亮的菜单名称（父级信息中的title值）注意：只有子页面才有该字段
    activeMenu：进入子页面时左侧菜单栏中高亮的菜单访问路径（父级信息中的path值）注意：只有子页面才有该字段

  注意：
      1、一级页面path配置：/ + 页面名称  如：/userManage
      2、二级页面path配置：一级页面path值 + / + 子页面名称   如：/userManage/userChild
      3、路由的 path 和 name 值走小驼峰形式
      4、应用名称取 vue.config.js 中的 publicPath 值，不需要 /，如：publicPath: '/base'，则应用名称为 base
*/

// 创建router-view
function createRouterView(name = Symbol('bgy')) {
  return {
    name,
    render: h => h('router-view')
  };
}

const dynamicRouters = [
  {
    path: '/',
    name: 'layout',
    component: () => import(/* webpackChunkName: "layout" */ '../views/layout/index.vue'),
    redirect: '/overview',
    hidden: true,
    children: [
      {
        path: '/overview',
        name: 'overview',
        component: () => import(/* webpackChunkName: "overview" */ '../views/overview/index.vue'),
        meta: {
          title: '能耗总览',
          icon: 'icon-gaikuangzonglan'
        }
      },
      {
        path: '/factoryManage',
        name: 'factoryManage',
        component: () => import(/* webpackChunkName: "factoryManage" */ '../views/factoryManage/index.vue'),
        meta: {
          title: '工厂管理',
          icon: 'icon-gongchangguanli'
        },
        children: [
          {
            path: 'factoryDetail',
            name: 'factoryDetail',
            component: () => import(/* webpackChunkName: "factoryDetail" */ '../views/factoryManage/detail.vue'),
            hidden: true,
            meta: {
              title: '详情',
              activeMenuName: 'factoryManage'
            }
          }
        ]
      },
      {
        path: '/energyManage',
        name: 'energyManage',
        component: createRouterView('energyManage'),
        redirect: '/energyManage/energySet',
        meta: {
          title: '能源管理',
          icon: 'icon-nengyuanguanli'
        },
        children: [
          {
            path: 'energySet',
            name: 'energySet',
            component: () => import(/* webpackChunkName: "energySet" */ '../views/energyManage/EnergySet.vue'),
            meta: {
              title: '能源配置'
            }
          },
          {
            path: 'meter',
            name: 'meter',
            component: () => import(/* webpackChunkName: "meter" */ '../views/energyManage/Meter.vue'),
            meta: {
              title: '计量仪表'
            }
          },
          {
            path: 'energyUsePlan',
            name: 'energyUsePlan',
            component: () => import(/* webpackChunkName: "energyUsePlan" */ '../views/energyManage/EnergyUsePlan.vue'),
            meta: {
              title: '用能计划'
            }
          }
        ]
      },
      {
        path: '/reportAnalysis',
        name: 'reportAnalysis',
        component: createRouterView('reportAnalysis'),
        redirect: '/reportAnalysis/costAnalysis',
        meta: {
          title: '报表分析',
          icon: 'icon-baobiaofenxi'
        },
        children: [
          {
            path: 'costAnalysis',
            name: 'costAnalysis',
            component: () => import(/* webpackChunkName: "costAnalysis" */ '../views/reportAnalysis/CostAnalysis.vue'),
            meta: {
              title: '成本分析'
            }
          },
          {
            path: 'planAssess',
            name: 'planAssess',
            component: () => import(/* webpackChunkName: "planAssess" */ '../views/reportAnalysis/PlanAssess.vue'),
            meta: {
              title: '计划考核'
            }
          },
        ]
      },
      {
        path: '/energyStatic',
        name: 'energyStatic',
        component: createRouterView('energyStatic'),
        redirect: '/energyStatic/energyTrend',
        meta: {
          title: '能源统计',
          icon: 'icon-nengyuantongji'
        },
        children: [
          {
            path: 'energyTrend',
            name: 'energyTrend',
            component: () => import(/* webpackChunkName: "energyTrend" */ '../views/energyStatic/EnergyTrend.vue'),
            meta: {
              title: '能源流向'
            }
          },
          {
            path: 'energyUseStatic',
            name: 'energyUseStatic',
            component: () => import(/* webpackChunkName: "energyUseStatic" */ '../views/energyStatic/EnergyUseStatic.vue'),
            meta: {
              title: '用能统计'
            }
          },
        ]
      },
      {
        path: '/resourceManage',
        name: 'resourceManage',
        component: createRouterView('resourceManage'),
        redirect: '/resourceManage/gatewayManage',
        meta: {
          title: '资源管理',
          icon: 'icon-ziyuanguanli'
        },
        children: [
          // {
          //   path: '/gatewayManage',
          //   name: 'gatewayManage',
          //   component: () => import(/* webpackChunkName: "gatewayManage" */ '../views/gatewayManage/index.vue'),
          //   meta: {
          //     title: '网关管理'
          //   },
          //   children: [
          //     {
          //       path: 'gatewayDetail',
          //       name: 'gatewayDetail',
          //       component: () =>
          //         import(/* webpackChunkName: "gatewayDetail" */ '../views/gatewayManage/GatewayDetail.vue'),
          //       hidden: true,
          //       meta: {
          //         title: '详情',
          //         activeMenuName: 'gatewayManage'
          //       }
          //     }
          //   ]
          // },
          {
            path: '/spaceManage',
            name: 'spaceManage',
            component: () => import(/* webpackChunkName: "spaceOverview" */ '../views/spaceManage/SpaceOverview.vue'),
            meta: {
              title: '空间管理'
            }
          },
          {
            path: '/messageManage',
            name: 'messageManage',
            component: () => import(/* webpackChunkName: "messageManage" */ '../views/smsManage/SmsOverview.vue'),
            meta: {
              title: '短信管理'
            }
          },
          {
            path: '/iotCardManage',
            name: 'iotCardManage',
            component: () => import(/* webpackChunkName: "iotCardManage" */ '../views/iotCardManage/CardList.vue'),
            meta: {
              title: '物联卡管理'
            }
          }
        ]
      },
      {
        path: '/dataLargeScreen',
        name: 'dataLargeScreen',
        component: createRouterView('dataLargeScreen'),
        redirect: '/dataLargeScreen/my',
        meta: {
          title: '数据大屏',
          icon: 'icon-shujudaping'
        },
        children: [
          {
            path: 'my',
            name: 'my',
            component: () => import(/* webpackChunkName: "my" */ '../views/dataLargeScreen/My.vue'),
            meta: {
              title: '我的大屏'
            }
          },
          {
            path: 'template',
            name: 'template',
            component: () => import(/* webpackChunkName: "template" */ '../views/dataLargeScreen/Template.vue'),
            meta: {
              title: '模板中心'
            }
          },
          {
            path: 'dataSource',
            name: 'dataSource',
            component: () => import(/* webpackChunkName: "dataSource" */ '../views/dataLargeScreen/DataSource.vue'),
            meta: {
              title: '数据源'
            }
          }
        ]
      },
      {
        path: '/organizationManage',
        name: 'organizationManage',
        component: createRouterView('organizationManage'),
        redirect: '/organizationManage/companyManage',
        meta: {
          title: '组织机构',
          icon: 'icon-zuzhiguanli'
        },
        children: [
          {
            path: 'companyManage',
            name: 'companyManage',
            component: () =>
              import(/* webpackChunkName: "companyManage" */ '../views/organizationManage/CompanyManage.vue'),
            meta: {
              title: '企业信息'
            }
          },
          {
            path: 'userManage',
            name: 'userManage',
            component: () => import(/* webpackChunkName: "userManage" */ '../views/organizationManage/UserManage.vue'),
            meta: {
              title: '用户管理'
            },
            children: [
              {
                path: 'departmentManage',
                name: 'departmentManage',
                component: () =>
                  import(/* webpackChunkName: "departmentManage" */ '../views/organizationManage/DepartmentManage.vue'),
                meta: {
                  title: '部门管理',
                  activeMenuName: 'userManage'
                }
              }
            ]
          },
          {
            path: 'roleManage',
            name: 'roleManage',
            component: () => import(/* webpackChunkName: "roleManage" */ '../views/organizationManage/RoleManage.vue'),
            meta: {
              title: '角色管理'
            },
            children: [
              {
                path: 'addOrModifyRole',
                name: 'addOrModifyRole',
                component: () =>
                  import(/* webpackChunkName: "addOrModifyRole" */ '../views/organizationManage/AddOrModifyRole.vue'),
                hidden: true,
                meta: {
                  title: '新增角色',
                  activeMenuName: 'roleManage'
                }
              }
            ]
          }
        ]
      },
      {
        path: '/notice',
        name: 'notice',
        component: () => import(/* webpackChunkName: "notice" */ '@/views/messageCenter/index.vue'),
        meta: {
          title: '消息中心',
          icon: 'icon-xiaoxizhongxin'
        }
      },
      {
        path: '/systemManage',
        name: 'systemManage',
        component: createRouterView('systemManage'),
        redirect: '/systemManage/systemSet',
        meta: {
          title: '系统管理',
          icon: 'icon-xitongguanli'
        },
        children: [
          {
            path: 'systemLogs',
            name: 'systemLogs',
            component: () => import(/* webpackChunkName: "systemLogs" */ '../views/systemManage/SystemLogs.vue'),
            meta: {
              title: '系统日志'
            }
          },
          {
            path: 'systemSet',
            name: 'systemSet',
            component: () => import(/* webpackChunkName: "systemSet" */ '../views/systemManage/SystemSet.vue'),
            meta: {
              title: '系统设置'
            }
          }
        ]
      },
      {
        path: '/personalCenter',
        name: 'personalCenter',
        hidden: true,
        component: () => import(/* webpackChunkName: "personalCenter" */ '../views/personalCenter/index.vue'),
        meta: {
          title: '个人中心'
        }
      }
    ]
  }
];

export default dynamicRouters;
